import { render } from "./AdminProduct.vue?vue&type=template&id=243ca150&scoped=true"
import script from "./AdminProduct.vue?vue&type=script&lang=js"
export * from "./AdminProduct.vue?vue&type=script&lang=js"

import "./AdminProduct.vue?vue&type=style&index=0&id=243ca150&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243ca150"]])

export default __exports__